import { number } from 'yup';
import { db } from './db';

type SiteDuplicateValues = {
  year?: string | number;
  fieldoffice?: string;
  projectId?: string | number;
  segmentId?: string | number;
  bend?: string | number;
  bendrn?: string;
};

type DuplicateSiteOptions = {
  noClientId?: string;
  noSiteId?: string | number;
};

const normalizeNumber = (value: unknown) => {
  if (value === undefined || value === null || value === '') {
    return null;
  }

  const numberValue = Number(value);

  return Number.isNaN(numberValue) ? null : numberValue;
};

const normalizeString = (value: unknown) => {
  return String(value ?? '')
    .trim()
    .toUpperCase();
};

export function isDuplicateSite(site: any, values: SiteDuplicateValues, options: DuplicateSiteOptions = {}) {
  const siteId = site.siteId ?? site.site_id;
  if (options.noClientId && site.clientId === options.noClientId) {
    return false;
  }

  if (options.noSiteId != null && siteId != null && normalizeNumber(siteId) === normalizeNumber(options.noSiteId)) {
    return false;
  }

  return (
    normalizeNumber(site.year) === normalizeNumber(values.year) &&
    normalizeString(site.fieldoffice) === normalizeString(values.fieldoffice) &&
    normalizeNumber(site.projectId ?? site.project_id) === normalizeNumber(values.projectId) &&
    normalizeNumber(site.segmentId ?? site.segment_id) === normalizeNumber(values.segmentId) &&
    normalizeNumber(site.bend) === normalizeNumber(values.bend) &&
    normalizeString(site.bendrn) === normalizeString(values.bendrn)
  );
}

export async function findDuplicateSite(values: SiteDuplicateValues, options: DuplicateSiteOptions = {}) {
  const sites = await db.sites.toArray();
  const duplicate = sites.find((site) => isDuplicateSite(site, values, options));

  return duplicate ?? null;
}
